/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function messagesSlider() {
  var slider = document.querySelector('.info__messagesSlider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    pageDots: false,
    adaptiveHeight: false
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.info__messagesSlider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
